
import { Component, Prop, Vue } from "vue-property-decorator";

/** Brand blue while the target is being worked towards, green once it is met. */
const IN_PROGRESS = "#1f7ab8";
const MET = "#2e8b4f";
const TRACK = "#e8e8e8";
const INK = "#363636";
const INK_MUTED = "#8b8b8b";

@Component
export default class GoalsDiagram extends Vue {
  @Prop()
  dataChart!: any;

  @Prop()
  header?: string;

  @Prop({ required: false })
  loading?: boolean;

  /** The same wording the target is captured under, so the two agree. */
  get getHeader() {
    return this.header === "Existing Customers Target"
      ? "Existing Clients (monthly)"
      : "New Clients (monthly)";
  }

  get amountVal() {
    return this.dataChart?.amount || 0;
  }

  get earnedVal() {
    return this.dataChart?.earned || 0;
  }

  get sumPriceVal() {
    return this.dataChart?.sumPrice || 0;
  }

  /**
   * The API sends these through number_format, so they arrive as "1,234.56".
   * An empty string used to be handed to the chart as its value, which drew
   * nothing at all rather than an empty ring.
   */
  get progressVal(): number {
    const raw = this.dataChart?.progress;
    if (raw === null || raw === undefined || raw === "") return 0;
    const value = Number(String(raw).replace(/,/g, ""));
    return Number.isFinite(value) ? Math.max(0, value) : 0;
  }

  get isMet(): boolean {
    return this.progressVal >= 100;
  }

  /**
   * Computed rather than a static field patched by a watcher through $refs —
   * the ring now follows its data on its own.
   */
  get chartOptions() {
    return {
      chart: { fontFamily: "inherit", animations: { enabled: false } },
      colors: [this.isMet ? MET : IN_PROGRESS],
      labels: ["of target"],
      stroke: { lineCap: "round" },
      plotOptions: {
        radialBar: {
          hollow: { size: "62%" },
          track: { background: TRACK, strokeWidth: "100%" },
          dataLabels: {
            showOn: "always",
            name: {
              offsetY: 22,
              color: INK_MUTED,
              fontSize: "13px"
            },
            value: {
              offsetY: -16,
              color: INK,
              fontSize: "30px",
              fontWeight: 600,
              formatter: (value: number) => `${Number(value).toFixed(1)}%`
            }
          }
        }
      }
    };
  }
}
